import { AsyncPipe } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { INavItem, ITag } from '../../modules/cart/catalog/catalog-models';
import { CatalogService } from '../../modules/cart/catalog/catalog.service';
import { CategoryService } from '../../modules/category/category.service';
import { UserService } from '../../modules/common/user.service';
import { Constants } from '../../modules/constants';
import { IShopUser } from '../../modules/session/customer-models';
import { TranslateComponent } from '../../modules/translation/translate.component';
import { uxCartRouterCommands } from '../../modules/util/locale-util';

/**
 * Full shop mega-menu rendered inside the dotcom nav header.
 * Mirrors the layout of the original main-header shop dropdown:
 *   - Shop by Lifestyle (tag links, when available)
 *   - Shop by Category (category columns with sub-items)
 *   - Shop by Body Benefit (tag links, when available)
 *   - Shop All Products / Featured / My Health Pak footer links
 */
@Component({
    selector: 'shop-nav-full-menu',
    templateUrl: './shop-nav-full-menu.component.html',
    styleUrls: ['./shop-nav-full-menu.component.scss'],
    standalone: true,
    imports: [AsyncPipe, RouterModule, TranslateComponent],
})
export class ShopNavFullMenuComponent implements OnInit, OnDestroy {

    @Input() mobile = false;
    @Output() closeMenu = new EventEmitter<void>();

    nav$: Observable<INavItem[]>;
    lifestyles$: Observable<ITag[]>;
    bodyBenefits$: Observable<ITag[]>;

    showBuildMhpLink = false;

    private userSub: Subscription;

    constructor(
        private categoryService: CategoryService,
        private catalogService: CatalogService,
        private userService: UserService,
    ) {}

    ngOnInit(): void {
        this.nav$ = this.categoryService.getNavCategories();
        this.lifestyles$ = this.categoryService.getLifeStyles();
        this.bodyBenefits$ = this.categoryService.getBodyBenefits();
        this.userSub = this.userService.getShopUser().subscribe((user: IShopUser) => {
            this.showBuildMhpLink = !!user?.config?.showBuildMhpLink;
        });
    }

    ngOnDestroy(): void {
        this.userSub?.unsubscribe();
    }

    catalogRoute(id: number): (string | number)[] {
        return uxCartRouterCommands(Constants.CATALOG_STATE, id);
    }

    tagRoute(id: number): (string | number)[] {
        return uxCartRouterCommands(Constants.TAG_CATALOG_STATE, id);
    }

    readonly landingRoute = uxCartRouterCommands(Constants.LANDING_STATE);
    readonly mhpRoute = uxCartRouterCommands(Constants.MHP_STATE, Constants.MHP_WHY_STATE);

    navigate(): void {
        this.catalogService.clearFilters();
        this.closeMenu.emit();
    }
}
